<template>
  <ul class="notifications" v-if="notifications.length">
    <li
      v-for="notification in notifications"
      :class="'notification ' + notification.type"
      :key="notification.uuid"
    >
      <span v-text="notification.text"></span>
      <button
        type="button"
        class="icon-only"
        @click="dismiss(notification.uuid)"
      >
        <i class="icon icon-close">𝗑</i>
      </button>
    </li>
  </ul>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreMutations } from '@/store';

@Component
export default class Notifications extends Vue {
  get notifications() {
    return this.$store.state.notifications;
  }

  dismiss(uuid) {
    this.$store.commit(StoreMutations.Dismiss, uuid);
  }
}
</script>
